import { render, staticRenderFns } from "./ProjectPreview.vue?vue&type=template&id=3b33c56b&scoped=true"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"
import style0 from "./ProjectPreview.vue?vue&type=style&index=0&id=3b33c56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33c56b",
  null
  
)

export default component.exports